import { toast } from "sonner";
import { StatusChip } from "../../components/data/StatusChip";
import { RowActions } from "../../components/data/RowActions";
import { openOfficialDoc } from "../../api/docPrint";
import { fmtMoney } from "../../lib/format";
import { localName } from "../../lib/localName";

const KIND_OF = { purchase_order: "purchase_order", bill: "purchase_bill" };

const money = (doc) => `${doc.money?.currency || ""} ${fmtMoney(doc.totals?.payable)}`;

// أعمدة جداول مستندات المشتريات (نفس ترتيب أعمدة التصميم المعتمد).
export const docColumns = ({ t, i18n, onOpen, onDelete, onAttach }) => [
  { key: "number", label: t("purchases.cols.number"),
    render: (doc) => (
      <span className="num font-mono text-xs font-bold text-primary" dir="ltr">
        {doc.number || t("purchases.noNumber")}
      </span>
    ) },
  { key: "date", label: t("purchases.cols.date"),
    render: (doc) => <span className="num font-mono text-[11px] text-muted-foreground">{doc.date}</span> },
  { key: "supplier", label: t("purchases.cols.supplier"),
    render: (doc) => (
      <span className="block max-w-[260px] truncate text-xs font-bold">
        {(i18n.language === "ar" ? localName(doc.supplier) : null)
          || doc.supplier?.legal_name || t("purchases.internal")}
      </span>
    ) },
  { key: "total", label: t("purchases.cols.total"),
    render: (doc) => <span className="num font-mono text-xs font-bold">{money(doc)}</span> },
  { key: "state", label: t("purchases.cols.state"),
    render: (doc) => <StatusChip state={doc.state} /> },
  { key: "actions", label: t("purchases.cols.actions"),
    render: (doc) => (
      <RowActions
        testid={`doc-actions-${doc.id}`}
        actions={[
          { key: "view", title: t("purchases.cols.view"), onClick: () => onOpen(doc) },
          { key: "print", title: t("docs.openOfficial"), disabled: !KIND_OF[doc.doc_type],
            onClick: () =>
              openOfficialDoc(KIND_OF[doc.doc_type], doc.id)
                .catch(() => toast.error(t("errors.generic"))) },
          ...(onAttach
            ? [{ key: "attach", title: doc.supplier_invoice_attachment
                                    ? (doc.supplier_invoice_attachment.filename || t("purchases.attach.badge"))
                                    : t("purchases.attach.title"),
                 dot: doc.supplier_invoice_attachment ? "emerald" : null,
                 onClick: () => onAttach(doc) }]
            : []),
          ...(onDelete
            ? [{ key: "delete", title: t("app.delete"), onClick: () => onDelete(doc) }]
            : []),
        ]}
      />
    ) },
];
